import React from 'react';
import { SVGS } from '../../../assets';
import { ZoInputText } from '../../../zo-input-text-temp/zo-input-text-temp';
import './waba-signup.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';

interface WabaSignupProps {
  isLoading: boolean;
  mobileNumber: string;
  onBackClick: () => void;
  onContinueClick: () => void;
  updateMobileNumber: (phoneNumber: string) => void;
  wabaData: any;
}
export const WabaSignup: React.FC<WabaSignupProps> = ({
  isLoading,
  mobileNumber,
  onBackClick,
  onContinueClick,
  updateMobileNumber,
  wabaData,
}) => {
  return (
    <div className="waba-signup primary-font-regular">
      <div className="waba-signup-container">
        <div className="waba-signup-container-header">
          <div className="waba-signup-container-header-logo">
            <img src={SVGS.MetaIcon} alt="" className="meta-icon" />
            <img src={SVGS.RefreshIcon} alt="" className="refresh-icon" />
            <img src={SVGS.ZotokIcon} alt="" className="zotok-icon" />
          </div>
          <div className="waba-signup-container-header-text">
            <span className="waba-signup-container-header-text-heading primary-font-bold">
              WABA Sign Up
            </span>
            <span className="waba-signup-container-header-text-description primary-font-regular">
              WABA will be created with these details
            </span>
          </div>
        </div>
        <div className="waba-signup-container-body">
          <div className="waba-signup-container-body-input">
            <img
              src={SVGS.TradeIcon}
              alt=""
              className="waba-signup-container-body-input-icon"
            />
            <ZoInputText
              onBlur={() => {}}
              name=""
              title="Firm Name"
              disabled={true}
              value={wabaData?.displayName}
              placeholder="Firm Name"
            />
          </div>
          <div className="waba-signup-container-body-input">
            <img
              src={SVGS.EmailIcon}
              alt=""
              className="waba-signup-container-body-input-icon"
            />
            <ZoInputText
              onBlur={() => {}}
              name=""
              title="Email Id"
              disabled={true}
              value={wabaData?.email}
              placeholder="Email Id"
            />
          </div>
          <div className="waba-signup-container-body-input">
            <img
              src={SVGS.PhoneIcon}
              alt=""
              className="waba-signup-container-body-input-icon"
            />
            <ZoInputText
              onBlur={() => {}}
              name=""
              startAdornment={<span>+91</span>}
              title="Mobile Number"
              value={mobileNumber}
              disabled={true}
            />
          </div>
          {/* <div className="waba-signup-container-body-warning">
            <img src={SVGS.InfoError} alt="" />
            <span className="waba-signup-container-body-warning-text">
              This number is not registered with WhatsApp Business.{' '}
              <a href="https://www.Facebook.com/">Learn More</a>
            </span>
          </div>
          <div className="waba-signup-container-body-validating">
            <img src={SVGS.InfoBlueIcon} alt="" />
            <span className="waba-signup-container-body-validating-text">
              Validating...
            </span>
          </div>
          <div className="waba-signup-container-body-success">
            <img src={SVGS.InfoGreenIcon} alt="" />
            <span className="waba-signup-container-body-success-text">
              Registered with WhatsApp Business.
            </span>
          </div> */}
        </div>
      </div>
      <div className="waba-signup-footer">
        {/* <span className="waba-signup-footer-text">
          Click on the "Generate link" to generate a sign-up link
        </span> */}
        <div className="waba-signup-footer-buttons">
          <ZoButton
            onClick={onBackClick}
            label={'Back'}
            startIcon={<img src={SVGS.LeftArrowBlue} alt="" />}
            className="waba-signup-footer-buttons-back"
          />
          <ZoButton
            onClick={onContinueClick}
            label={'Launch Embedded Sign up'}
            isLoading={isLoading}
            className="waba-signup-footer-buttons-continue"
          />
        </div>
      </div>
    </div>
  );
};
